var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgU99Icn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 196,
    fill: "#612B73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9382 126.245L62.706 155.683H41.9918L61.7998 128.311H61.1525C53.9025 128.483 47.343 125.707 41.4739 119.983C35.6049 114.259 32.7567 107.395 32.9293 99.3898C32.7567 90.9545 35.8422 83.7242 42.186 77.6989C48.5297 71.6737 55.8876 68.7471 64.2596 68.9193C72.8043 68.9193 80.1837 71.8458 86.398 77.6989C92.6123 83.552 95.7194 90.8254 95.7194 99.5189C95.7194 104.253 94.77 108.471 92.8712 112.172C91.145 115.787 88.1673 120.478 83.9382 126.245ZM54.2907 109.59C57.0526 112.344 60.3755 113.721 64.2595 113.721C68.2297 113.721 71.5526 112.344 74.2282 109.59C76.9901 106.835 78.3711 103.435 78.3711 99.3899C78.3711 95.3444 77.0117 91.9229 74.2929 89.1254C71.5742 86.328 68.2297 84.9293 64.2595 84.9293C60.3755 84.9293 57.0526 86.3065 54.2907 89.0609C51.5288 91.8153 50.1479 95.2583 50.1479 99.3899C50.1479 103.435 51.5288 106.835 54.2907 109.59ZM130.065 155.683L151.297 126.245C155.526 120.478 158.504 115.787 160.23 112.172C162.129 108.471 163.078 104.253 163.078 99.519C163.078 90.8254 159.971 83.552 153.757 77.6989C147.542 71.8458 140.163 68.9193 131.618 68.9193C123.246 68.7471 115.888 71.6737 109.545 77.6989C103.201 83.7242 100.115 90.9545 100.288 99.3898C100.115 107.395 102.964 114.259 108.833 119.983C114.702 125.707 121.261 128.483 128.511 128.311H129.159L109.35 155.683H130.065ZM121.65 109.59C124.412 112.344 127.735 113.721 131.618 113.721C135.589 113.721 138.912 112.344 141.587 109.59C144.349 106.835 145.73 103.435 145.73 99.3899C145.73 95.3444 144.371 91.9229 141.652 89.1254C138.933 86.328 135.589 84.9293 131.618 84.9293C127.735 84.9293 124.412 86.3065 121.65 89.0609C118.888 91.8153 117.507 95.2583 117.507 99.3899C117.507 103.435 118.888 106.835 121.65 109.59Z",
    fill: "#FFA208"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2761,
    y: 40.3171,
    width: 95.448,
    height: 17.3542,
    fill: "#FFA208"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU99Icn);
export default __webpack_public_path__ + "static/media/u99_icn.2d76ff35cc7b610267f0781fb55f0ce0.svg";
export { ForwardRef as ReactComponent };